import { render, staticRenderFns } from "./PageBar.vue?vue&type=template&id=cd3f9dc8"
import script from "./PageBar.vue?vue&type=script&lang=js"
export * from "./PageBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports